const MEDIA_ITEMS = [
  {
    id: 1,
    title: '91国产经典影片回顾',
    desc: '重温91年最具代表性的国产电影佳作，感受那个年代独特的影像魅力与叙事风格。',
    duration: '1:28:36',
    category: '电影',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20scene%20with%20vintage%20film%20projector%20and%20soft%20golden%20lighting%2C%20nostalgic%20movie%20theater%20atmosphere%2C%20rich%20amber%20and%20crimson%20tones%2C%20classic%20Chinese%20cinema%20aesthetic%2C%20elegant%20composition%2C%20no%20people&width=800&height=500&seq=media-card-91video-01&orientation=landscape',
  },
  {
    id: 2,
    title: '热门国产电视剧连播',
    desc: '精选高分国产电视剧全集，从年代剧到现代都市剧，每一部都值得细细品味。',
    duration: '45:12',
    category: '电视剧',
    image: 'https://readdy.ai/api/search-image?query=Modern%20cozy%20living%20room%20with%20large%20TV%20screen%20displaying%20warm%20ambient%20glow%2C%20soft%20evening%20atmosphere%2C%20comfortable%20home%20entertainment%20setting%2C%20rich%20crimson%20and%20gold%20lighting%2C%20cinematic%20mood%2C%20no%20people&width=800&height=500&seq=media-card-91video-02&orientation=landscape',
  },
  {
    id: 3,
    title: '国产综艺精彩合集',
    desc: '汇集最受欢迎的国产综艺节目，搞笑、竞技、真人秀应有尽有，欢乐不间断。',
    duration: '1:12:45',
    category: '综艺',
    image: 'https://readdy.ai/api/search-image?query=Bright%20dynamic%20stage%20with%20colorful%20spotlights%20and%20warm%20atmosphere%2C%20entertainment%20show%20setting%20with%20rich%20lighting%20effects%2C%20vibrant%20amber%20and%20gold%20highlights%2C%20lively%20studio%20ambiance%2C%20no%20people&width=800&height=500&seq=media-card-91video-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-sm md:text-base text-foreground-500">编辑团队为您精选的91国产视频内容</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {MEDIA_ITEMS.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-2xl overflow-hidden group cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`91视频网站 - ${item.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-medium whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-0.5 rounded bg-black/60 text-white text-xs whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-white text-xl"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-bold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}